import React, { useState } from "react";
import { useToast } from "../../context/ToastContext";
import { apiClient } from "../../utils/http";
import PasswordFields from "./PasswordFields";
import { checkPasswords, reportError } from "./formErrors";

/* The store admin sets a new password for a user, to hand over to them. */
export default function ResetPasswordModal({ user, onClose }) {
  const showToast = useToast();
  const [form, setForm] = useState({ password: "", password_confirmation: "" });
  const [saving, setSaving] = useState(false);

  const update = (patch) => setForm((current) => ({ ...current, ...patch }));

  const submit = async (e) => {
    e.preventDefault();
    const errors = checkPasswords(form);
    if (errors) {
      reportError({ errors }, showToast, "reset");
      return;
    }

    setSaving(true);
    try {
      const res = await apiClient.post(`users/reset-password/${user.id}`, form);
      showToast(res.data.message);
      onClose();
    } catch (err) {
      setSaving(false);
      reportError(err, showToast, "reset");
    }
  };

  return (
    <div className="modal-backdrop no-print" style={{ zIndex: 1005 }}>
      <div className="modal-container modal-md">
        <div className="modal-header">
          <h3>🔑 Reset Password</h3>
          <button type="button" className="btn-icon-close" title="Close" onClick={onClose}>
            &times;
          </button>
        </div>
        <form onSubmit={submit} noValidate>
          <div className="modal-body">
            <p className="users-intro">
              Set a new password for <strong>{user.name}</strong> (@{user.username}) and share it with them.
            </p>
            <PasswordFields idPrefix="reset" form={form} onChange={update} label="New Password" />
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? "Saving..." : "Reset Password"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
